import { toPublicUrl } from "../../services/PublicUrl";
import i18n from "i18next";
import "./ImplementationGuidePage.css";

export default function ImplementationGuidePage() {
  const implementationGuideUrl = toPublicUrl("/ig/index.html");

  return (
    <main className="implementation-guide-page">
      <iframe
        className="implementation-guide-page__frame"
        src={implementationGuideUrl}
        title={i18n.t("accessibility.implementationguide")}
      />
    </main>
  );
}
